import React from 'react';
import { useTranslation } from 'react-i18next';
import type { UserRole } from '../../types';

interface RoleSelectorProps {
  value: UserRole;
  onChange: (role: UserRole) => void;
  disabled?: boolean;
}

export const RoleSelector: React.FC<RoleSelectorProps> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as UserRole)}
      disabled={disabled}
      className="form-control"
    >
      <option value="">
        {t('admin.userManagement.form.selectRole', 'Sélectionner un rôle')}
      </option>
      <option value="bureau">
        {t('admin.userManagement.roles.bureau', 'Bureau')}
      </option>
      <option value="admin">
        {t('admin.userManagement.roles.admin', 'Administrateur')}
      </option>
      <option value="expert">
        {t('admin.userManagement.roles.expert', 'Expert')}
      </option>
      <option value="client">
        {t('admin.userManagement.roles.client', 'Client')}
      </option>
      <option value="banque">
        {t('admin.userManagement.roles.banque', 'Banque')}
      </option>
    </select>
  );
};